module.exports = __webpack_public_path__ + "img/out-step2.f99a12ca.png";